import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Gauge = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12C12.1792 12 12.3528 12.0236 12.518 12.0677L14.7929 9.79289L16.2071 11.2071L13.9323 13.482C13.9764 13.6472 14 13.8208 14 14Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M22 14C22 16.2754 21.2401 18.3733 19.9601 20.0537C17 20 7 20 4.03988 20.0537C2.75995 18.3733 2 16.2754 2 14C2 8.47715 6.47715 4 12 4C17.5228 4 22 8.47715 22 14ZM11 6.06189C9.53929 6.24404 8.20088 6.81999 7.09436 7.68014L8.20711 8.79289L6.79289 10.2071L5.68014 9.09436C4.81999 10.2009 4.24404 11.5393 4.06189 13H5.5V15H4.06172C4.1984 16.0986 4.55748 17.1266 5.09281 18.0394C8.49387 18.0048 15.5061 18.0048 18.9072 18.0394C19.4425 17.1266 19.8016 16.0986 19.9383 15H18.5V13H19.9381C19.756 11.5393 19.18 10.2009 18.3199 9.09436L17.2071 10.2071L15.7929 8.79289L16.9056 7.68014C15.7991 6.81999 14.4607 6.24404 13 6.06189V7.5H11V6.06189Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Gauge;
